import React, { PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material';
import { SidebarMenu } from '@features/workspace/components/layouts/sidebar-menu';
import PageHeader from '@features/workspace/components/layouts/v1/page-header';
import { resolvePageMeta, pagesMeta } from '@app/services/pages-meta';
import { makeStyles } from 'tss-react/mui';
import { useLocation } from 'react-router-dom';
import { LayoutType } from '../const';

const useStyles = makeStyles<any>()({
  container: {
    display: 'flex',
    minHeight: '100vh',
  },
  sidebar: {
    display: 'flex',
    background: '#0F253B',
    paddingRight: '20px',
    flexShrink: 1,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    background: '#F5F6FA',
    borderTopLeftRadius: '20px',
    borderBottomLeftRadius: '20px',
    marginLeft: '-20px',
    padding: '52px',
  },
  pageHeader: {},
  pageContent: {
    marginTop: '-10px',
  },
  // TODO: define appropriate variant instead once theme covers it
  pageTitle: {
    color: '#4B4B4B !important',
  },
});

interface IProps {
  layoutType?: LayoutType;
}

export default function Layout({
  children,
  layoutType = LayoutType.CUSTOMER,
}: PropsWithChildren<IProps>): JSX.Element {
  const { classes } = useStyles(null);

  const pageMeta = resolvePageMeta();

  const location = useLocation();

  const hasRootPageHeader = pagesMeta.reduce((acc, meta: any) => {
    acc ||= meta.uri.includes(location.pathname);
    if (meta.hasLayoutHeaderRegex) {
      acc ||= location.pathname.match(meta.hasLayoutHeaderRegex) !== null;
    }

    return acc;
  }, false);

  return (
    <Box className={classes.container}>
      <Box className={classes.sidebar}>
        <SidebarMenu pageMeta={pageMeta} />
      </Box>
      <Box className={classes.content}>
        {hasRootPageHeader && (
          <>
            <Box alignItems="center" display="flex">
              <Box display="flex" ml={4}>
                {pageMeta?.headerIcon}
              </Box>
              <Box display="flex" flexGrow={1} ml={1}>
                <Typography className={classes.pageTitle} variant="h5">
                  {pageMeta?.headerTitle}
                </Typography>
              </Box>
            </Box>
            <Box className={classes.pageHeader} mt={3}>
              <PageHeader layoutType={layoutType} />
            </Box>
          </>
        )}
        <Box className={classes.pageContent} mt="-20px">
          {children}
        </Box>
      </Box>
    </Box>
  );
}
